import { Component, Input, OnChanges, OnInit, output, OutputEmitterRef, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, FormsModule, NumberValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '@libs/components/icons';
import { QuantityCounterInputModel } from '@libs/form/models';
import { InputAttributesDirective, InputValidatorsDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { InputProviderFactory } from '../ng-input-provider';

@Component({
  selector: 'ui-form-quantity-counter',
  templateUrl: './quantity-counter.component.html',
  styleUrls: ['./quantity-counter.component.scss'],
  providers: [
    ...InputProviderFactory.getProviders(QuantityCounterComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButtonToggleModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    InputValidatorsDirective,
    InputAttributesDirective,
    ReactiveFormsModule,
    IconComponent,
  ],
})
export class QuantityCounterComponent extends InputBaseComponent implements OnInit, OnChanges {
  @Input()
  public data!: QuantityCounterInputModel;

  @Input()
  public loading?: boolean = false;

  @ViewChild(NumberValueAccessor, { static: true })
  public valueAccessor!: ControlValueAccessor;

  public remove: OutputEmitterRef<void> = output();

  public min: number = 1;
  public max?: number;

  public decrement(): void {
    const value: number = Number(this.control.value);

    if (value === this.min) {
      return;
    }

    this.control.setValue(value - 1);
  }

  public increment(): void {
    const value: number = Number(this.control.value);

    if (this.max && value >= this.max) {
      return;
    }

    this.control.setValue(value + 1);
  }

  public onBlur(): void {
    if (!this.control.value || this.control.value < this.min) {
      this.control.setValue(this.min);
    }

    if (this.max && this.control.value > this.max) {
      this.control.setValue(this.max);
    }
  }

  public override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (this.data.attributes?.min) {
      this.min = Number(this.data.attributes.min);
    } else {
      this.min = 1;
    }

    if (this.data.attributes?.max) {
      this.max = Number(this.data.attributes.max);
    } else {
      this.max = undefined;
    }
  }
}
